export default __webpack_public_path__ + "static/media/movingFullStone.5747d2fc.gif";